// src/components/ErrorBoundary.jsx
import React, { Component } from 'react';
import { Container, Alert, Button } from 'react-bootstrap';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para que el siguiente renderizado muestre la UI alternativa.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // También puedes registrar el error en un servicio de reporte de errores
    console.error('Error capturado en ErrorBoundary:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleReload = () => {
    window.location.reload();
  }

  handleGoHome = () => {
    window.location.href = '/';
  }

  render() {
    if (this.state.hasError) {
      // Puedes renderizar cualquier UI alternativa
      return (
        <Container className="mt-5">
          <Alert variant="danger">
            <Alert.Heading>Algo salió mal</Alert.Heading>
            <p>
              Se ha producido un error en la aplicación. Esto podría deberse a un problema temporal.
            </p>
            <hr />
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="mb-3">
                <h5>Detalles del error (solo visible en desarrollo):</h5>
                <p>{this.state.error.toString()}</p>
                <pre className="border p-2 bg-light">
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </div>
            )}
            <div className="d-flex gap-2">
              <Button variant="primary" onClick={this.handleReload}>
                Recargar página
              </Button>
              <Button variant="secondary" onClick={this.handleGoHome}>
                Ir al inicio
              </Button>
            </div>
          </Alert>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;